
import React from 'react'
import Icons from '../Images'

export default function LiveChat({ OpenLiveChat, className = '' }) {
    return <div
        className={`liveChatContainer ${className}`}
        onClick={() => {
            OpenLiveChat({
                type: 'zoomOut'
            })
        }}>
        <img
            src={Icons.contact}
            className='contact'
        ></img>
    </div>
}